<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<b-form ref="instanceForm" id="instanceForm" @submit.prevent="handleSubmit()" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<div class="col-md-8">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsTeam')}}
									</label>

									<select v-model="prsTeamSelected" 
										class="form-control" :class="{'is-invalid': v$.instance.prsTeam.$error, 'is-valid': (!v$.instance.prsTeam.$error && v$.instance.prsTeam.$dirty) }" :disabled="typeView=='show'" @change="prsTeamChange()">
										<option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option>
										<option v-for="prsTeam in prsTeamList" :value="prsTeam.id" :key="prsTeam.id" >
										{{ prsTeam.lib }}
										</option>
									</select>
									<!-- <b-form-select
										class="form-control"
										v-model="prsTeamSelected" 
										value-field="id"
										text-field="lib"
										:options="prsTeamList"
										:class="{'is-invalid': v$.instance.prsTeam.$error, 'is-valid': (!v$.instance.prsTeam.$error && v$.instance.prsTeam.$dirty) }"
									/> -->

									<span class="small text-muted d-none d-md-block" v-if="v$.instance.prsTeam.$error">
										{{ v$.instance.prsTeam.$errors[0].$message }}
									</span>									
								</b-form-group>
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
								<!-- <div class="form-group"> -->
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.servDate')}}
									</label>
									<input type="date" v-model="instance.servDate" class="form-control" lang="fr"
									:class="{'is-invalid': v$.instance.servDate.$error, 'is-valid': (!v$.instance.servDate.$error && v$.instance.servDate.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.servDate.$error">
										{{ v$.instance.servDate.$errors[0].$message }}
									</span>
								</b-form-group>				
								<!-- </div> -->
							</div>
						
							<legend> <h6 class="fst-italic text-decoration-underline">ETAT DES SECHOIRS</h6></legend>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>Vide au début</label>
									<input type="number" v-model="instance.startEmpty" class="form-control" min="0"
									:class="{'is-invalid': v$.instance.startEmpty.$error, 'is-valid': (!v$.instance.startEmpty.$error && v$.instance.startEmpty.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.startEmpty.$error">
										{{ v$.instance.startEmpty.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>Vide à la fin</label>
									<input type="number" v-model="instance.endEmpty" class="form-control" min="0"
									:class="{'is-invalid': v$.instance.endEmpty.$error, 'is-valid': (!v$.instance.endEmpty.$error && v$.instance.endEmpty.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.endEmpty.$error">
										{{ v$.instance.endEmpty.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>Rempli au début</label>
									<input type="number" v-model="instance.startFull" class="form-control" min="0"
									:class="{'is-invalid': v$.instance.startFull.$error, 'is-valid': (!v$.instance.startFull.$error && v$.instance.startFull.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.startFull.$error">
										{{ v$.instance.startFull.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>Rempli à la fin</label>
									<input type="number" v-model="instance.endFull" class="form-control" min="0"
									:class="{'is-invalid': v$.instance.endFull.$error, 'is-valid': (!v$.instance.endFull.$error && v$.instance.endFull.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.endFull.$error">
										{{ v$.instance.endFull.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>	
						</div>
						
					</b-form>
					
				</div>
				<div class="card-body p-4 p-md-5">
					<!-- ENTETE -->

					<!-- Ops table-->
					<div class="table-responsive">
						<h6 class="fst-italic text-decoration-underline">Produit(s)</h6>
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="30%">
										{{ $t(instanceClassAttr.instanceClass+'.servType')}}
									</th>
									<th v-if="prsTeamTypeSelected == 'Emballage' " scope="col" width="10%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.quantity')}}
									</th>
									<th scope="col" width="15%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.quantitySec')}}
									</th>
									<th v-if="prsTeamTypeSelected == 'Emballage' " scope="col" width="15%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.cost')}}
									</th>
									<th v-if="prsTeamTypeSelected == 'Emballage' " scope="col" width="25%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.amount')}}
									</th>
									<th scope="col" v-if="typeView != 'show' && prsTeamTypeSelected == 'Emballage' " class="align-center">
										{{ $t('default.actions')}}
									</th>
								</tr>
							</thead>
							<tbody>
								<!-- PROD -->
								<!-- 1 -->
								<tr v-if="prsTeamTypeSelected == 'Production' " class="border-bottom">
									<td>
										<div class="font-weight-bold">
											<select v-model="servType1Selected" 
												class="form-control" :disabled="typeView=='show'">
												<option value="null" selected>
													{{$t('default.fill.field.message')}}
												</option>
												<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id" >
													{{ servType.typeName }}
												</option>
											</select>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" min="0" v-model="instance.sechType1" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>
								<!-- 2 -->
								<tr v-if="prsTeamTypeSelected == 'Production' " class="border-bottom">
									<td>
										<div class="font-weight-bold">
											<select v-model="servType2Selected" 
												class="form-control" :disabled="typeView=='show'">
												<option value="null" selected>
													{{$t('default.fill.field.message')}}
												</option>
												<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id" >
													{{ servType.typeName }}
												</option>
											</select>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" min="0" v-model="instance.sechType2" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>
								<!-- 3 -->
								<tr v-if="prsTeamTypeSelected == 'Production' " class="border-bottom">
									<td>
										<div class="font-weight-bold">
											<select v-model="servType3Selected" 
												class="form-control" :disabled="typeView=='show'">
												<option value="null" selected>
													{{$t('default.fill.field.message')}}
												</option>
												<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id" >
													{{ servType.typeName }}
												</option>
											</select>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" min="0" v-model="instance.sechType3" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>
								<!-- 4 -->
								<tr v-if="prsTeamTypeSelected == 'Production' " class="border-bottom">
									<td>
										<div class="font-weight-bold">
											<select v-model="servType4Selected" 
												class="form-control" :disabled="typeView=='show'">
												<option value="null" selected>
													{{$t('default.fill.field.message')}}
												</option>
												<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id" >
													{{ servType.typeName }}
												</option>
											</select>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" min="0" v-model="instance.sechType4" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>

								<!-- EMB -->
								<tr v-if="prsTeamTypeSelected == 'Emballage' " class="border-bottom" v-for="servOp in instance.servOps" :key="servOp.id">
									<td>
										<div class="font-weight-bold">
											{{servOp.servTypeLib}}
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" v-model="servOp.quantity" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" min="0" v-model="servOp.quantitySec" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
									<td>
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount(servOp.cost)}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount( servOp.cost * servOp.quantity )}}
										</div>
									</td>
									<td v-if="typeView != 'show'" class="align-center">
										<!-- font-weight-bold -->
										<div class=""> 
											<button class="btn btn-danger btn-icon btn-xs" @click="removeRow(servOp)">
												<fa icon="minus"/>
											</button>
										</div>
									</td>
								</tr>
								<tr v-if="typeView != 'show' && prsTeamTypeSelected == 'Emballage' " class="border-bottom table-warning">
									<td v-show="activeAddRow" align="center" colspan="6" >
										<!-- :linkObject="linkObject" -->
										<auto-search :paramsSearch="paramsSearch" @updateOnClick="addRow" />
									</td>
									<td v-show="!activeAddRow" align="center" colspan="6"
									>
										<b-button class="btn btn-sm btn-success" 
											@click="activeAddRow=true" >
											<span>
												<fa class="fa-lg" icon="plus-circle"/>
											</span>
										</b-button>
									</td>
								</tr>
				
							</tbody>
						</table>
					</div>
					<hr>
					<!-- Absences & Obs. -->
					<div v-if="this.instance.prsSuiviList && this.instance.prsSuiviList.length > 0" class="table-responsive">
						<!-- <caption>Absence(s)</caption> -->
						<h6 class="fst-italic text-decoration-underline">Absence(s)</h6>
						<table id="instanceTableSuivi" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="40%">
										{{ $t(instanceClassAttr.instanceClass+'.prsSuivi')}}
									</th>
									<th scope="col" width="60%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.motif')}}
									</th>
									
								</tr>
							</thead>
							<tbody>
								<tr class="border-bottom" v-for="prsSuivi in this.instance.prsSuiviList" :key="prsSuivi.id">
									<td>
										<div class="font-weight-bold">
											{{prsSuivi.prsFullName}}
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="text" v-model="prsSuivi.motif" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>
								
							</tbody>
						</table>
					</div>
					<hr>
					<!-- <legend> </legend> -->
					<div class="col-md-12">
						<b-form-group class="small mb-1">
							<label class="fst-italic text-decoration-underline">
								{{ $t(instanceClassAttr.instanceClass+'.observation')}}&ensp; | Commentaire (Problèmes, Pannes, Solutions, Suggestions, etc.)
							</label>
							<textarea v-model="instance.observation" class="form-control" rows="2" :disabled="typeView=='show'"/>
						</b-form-group>
					</div>

				</div>

				<div class="card-footer">
					<div class="row">
						<div class="col-md-4" align="left">
							<b-button v-if="typeView != 'show'" class="btn btn-success" 
								@click="handleSubmit()" >
								<span v-if="typeView == 'new'">
									<fa icon="check"/>
									{{ $t("default.button.create")}}
								</span>
								<span v-if="typeView == 'edit'">
									<fa icon="check"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="typeView = 'show' " >
								<span>
									<fa icon="times"/>
									{{ $t("default.button.cancel")}}
								</span>
							</b-button>
							
							<b-button v-if="typeView == 'show'" class="btn btn-primary" 
								@click="typeView = 'edit' " >
								<span>
									<fa icon="edit"/>
									{{ $t("default.button.edit")}}
								</span>
							</b-button>
						</div>
						<div class="col-md-4" align="center">
							
						</div>
						<div v-if="typeView == 'show'" class="col-md-4" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce()">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('prodorder.button.bord')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>
					</div>

				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'	

	import AutoSearch from '@/components/templates/AutoSearch.vue';
	
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'


	export default {
		name: 'servTeam',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		
		setup () { return { v$: useVuelidate() }},
		// setup: () => ({ v$: useVuelidate() }),
		components: {
			'header-layout': Header,
			'auto-search': AutoSearch,
			'modal-pdf-viewer': ModalPdfViewer
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('servteam.label'),
				pageTitle: this.$t('servteam.list'),
				pageIcon: 'random',
				instanceClassAttr: {
					instanceClass: 'servteam',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '10%',
						// actAlign: 'right',
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true
					},
					attrsList: [
						{attrName: 'id', attrCol: '10%', searchable: true, sortable: true},
						{attrName: 'prsTeamLib', attrCol: '20%', searchable: false, sortable: true},
						{attrName: 'servDate', attrCol: '20%', searchable: false, sortable: true},
						{attrName: 'servTypeLib', attrCol: '20%', searchable: false, sortable: true},
						// {attrName: 'servOp', attrCol: '20%', searchable: false, sortable: true},
						
						{attrName: 'username', attrCol: '20%', searchable: true, sortable: false}
					]
				},

				instance: {
					servDate: new Date ().toISOString().split('T')[0], // this.$moment(new Date ()).format('YYYY-MM-DD').toString()
					startFull: 0,
					startEmpty: 0,
					endFull: 0,
					endEmpty:0, 
					servOps:[],
					prsSuiviList:[]
				},
				vueRules: {},
				// linkObject: {},
				paramsSearch: {
					placeholder: 'Search Product',
					instanceClass: 'servtypestockes',
					attrsSearch : ['typeName'],
					
					attrView: 'servTypeLib',
					filterList: [],
					icon: 'cart-plus',
					btnReturn: true,
				},
				prsTeamList: [],
				prsTeamSelected: null,
				prsTeamTypeSelected:'',

				servTypeList: [],
				servType1Selected: null,
				servType2Selected: null,
				servType3Selected: null,
				servType4Selected: null,

				// addOp
				activeAddRow: false,
				rowsAdded: {},
				typeView: 'new', // new, show, edit

				pdfSrc:'',
				pdfName:'Fiche de Suivi',					
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			
			this.vueRules = this.createVeerules()
		}, 
		async mounted () {
			
			this.$store.dispatch('initFlash');
			/*this.$nextTick(() => {
				this.$store.dispatch('unloading')
			})*/
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsteam'
				})
				.then(response => {
					this.prsTeamList = response.data
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				// GET LIST servTypeStockESList
				let strParams = "typeRender=list"
				// PDT			
				// E -> 1, S -> 2
				strParams = strParams+"&params1=servTypeES.id&valParams1="+1+"&logParams1=eqL"
				// S -> 1, P -> 2, V -> 3,
				strParams = strParams+"&params2=servService.id&valParams2="+2+"&logParams2=eqL"
				strParams = strParams+"&aliasList=_servType"
				// ART -> 1, PDT -> 2
				strParams = strParams+"&params3=_servType.servCategory.id&valParams3="+ 2+"&logParams3=eqL"
				
				await this.$store.dispatch('axiosGet', { 
					url: '/api/servtypestockes/getbycriteria?' + strParams
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

				// GET LIST servTypeList
				let strParams1 = "typeRender=list"
				// PDT			
				// ART -> 1, PDT -> 2
				strParams1 = strParams1+"&params3=servCategory.id&valParams3="+ 2+"&logParams3=eqL"
				
				await this.$store.dispatch('axiosGet', { 
					url: '/api/servtype/getbycriteria?' + strParams1
				})
				.then(response => {
					this.servTypeList = response.data
				})
				.catch(error => {
					console.log('error catch servTypeList == ', error.message)
				})
			
				if(this.itemId && !isNaN(this.itemId)){

					await this.$store.dispatch('axiosGet', {
						domain: 'servteam',
						id: this.itemId
					})
					.then(response => {
						this.typeView = 'show'
						this.instance = response.data
						this.instance.servDate = this.$moment(this.instance.servDate).format('YYYY-MM-DD').toString()
						this.instance.servOps = this.instance.servOp
						this.instance.servOps.forEach(servOp => {
							// console.log('servOp.id === ', servOp.id)
							servOp.id = servOp.servTypeStockES?.id
						})
						this.instance.servOp = []

						this.prsTeamSelected = this.instance.prsTeam.id
						this.prsTeamTypeSelected = this.instance.prsTeam.teamType

						this.servType1Selected = this.instance.servType1? this.instance.servType1.id : null
						this.servType2Selected = this.instance.servType2 ? this.instance.servType2.id : null
						this.servType3Selected = this.instance.servType3? this.instance.servType3.id : null
						this.servType4Selected = this.instance.servType4? this.instance.servType4.id : null
						// corrige multi-save in backend
						this.prsTeamChange()
						//this.instance.prsSuiviList = this.instance.prsSuivis
						
					})
					.catch(error => {
						console.log('error catch get servteam by itemId == ', error.message)
					})
				}
			}
			this.pageTitle = this.$t('servteam.'+this.typeView)
		},
		methods: {
			createVeerules(){
				let rules = {
					instance: {
						prsTeam: {required},
						servDate: { required },
						startEmpty: {required},
						endEmpty: { required },
						startFull: {required},
						endFull: { required },
					}
				}
				return rules
			},
			prsTeamChange(){
				
				// CAS EDIT - List EMB ou PROD 
				if(this.itemId && !isNaN(this.itemId) && this.instance.prsTeam )
					this.prsTeamList = this.prsTeamList.filter(item => item.teamType == this.instance.prsTeam.teamType)

				this.instance.prsSuiviList = [];

				let prsTeam = this.prsTeamList.filter(item => item.id == this.prsTeamSelected)
				if(prsTeam && prsTeam.length > 0 && prsTeam[0].prsMembers && prsTeam[0].prsMembers.length > 0){
					this.prsTeamTypeSelected = prsTeam[0].teamType
					prsTeam[0].prsMembers.forEach(prsMember => {
						// CAS EDIT
						let motif = ''
						if(this.instance.prsSuivis){
							this.instance.prsSuivis.forEach(prsSuivi => {
								if(prsSuivi?.prsPerson.id == prsMember?.id)
									motif = prsSuivi?.motif
							});
						}
						this.instance.prsSuiviList.push({
							prsFullName: prsMember.fullName,
							prsPerson: prsMember,
							motif: motif //''
						})
					});
					// this.instance.prsSuiviList = prsTeam[0].prsMembers
				}
			},
			removeRow(row){
				let newList = this.instance.servOps.filter(item => item.id !== row.id)
				this.instance.servOps = newList
				this.paramsSearch.filterList.push(this.rowsAdded[row.id])
			},
			addRow(row){
				if(row){
					let servOp = {
						id: row.id,
						servTypeLib: row.servTypeLib,
						quantity: 0,
						quantitySec:0,
						cost: row.cost
					}
					// on restraint la liste filter after click
					let newList = this.paramsSearch.filterList.filter(item => item.id !== row.id)
					this.paramsSearch.filterList = newList
					
					// cas edit, on bloque l'élement existant dans l'opération
					const idRowsAdded = this.instance.servOps.map(item => item.servTypeStockES?.id);
					if(idRowsAdded?.includes(row.id)){
						this.$store.dispatch('showToast', {
							type: 'warning', message: row.servTypeLib +' déja choisis'
						});
					}
					else {
						this.instance.servOps.push(servOp)
						this.rowsAdded[row.id] = row
					}
				
				}
				if(this.activeAddRow)
					this.activeAddRow = false
				else
					this.activeAddRow = true
			},
			async handleSubmit() {
				this.instance.prsTeam = this.prsTeamSelected
				this.instance.servType1 = this.servType1Selected
				this.instance.servType2 = this.servType2Selected
				this.instance.servType3 = this.servType3Selected
				this.instance.servType4 = this.servType4Selected
				// console.log('this.instance.prsSuiviList == ', this.instance.prsSuiviList)
				const result = await this.v$.$validate()
				if (!result){
					return
				}
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						console.log( 'axiosPut === ',this.itemId )
						await this.$store.dispatch('axiosPut', {
							domain: 'servteam',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("servteam.label") + " "+res.data.id;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.updated.message', { obj: msg})
								});
								this.typeView = 'show'
								this.$router.push('/servteam/show/'+res.data.id)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'servteam',
							data: this.instance //data
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("servteam.label") + " "+res.data.id;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.created.message', { obj: msg})
								});
								this.$router.push('/servteam/show/'+res.data.id)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							// console.log('Error', error.response)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = 'FICHE DE SUIVI'
				let attrsRepList = ['getServType()', 'quantitySec', 'quantity', 'tdObs']
				let attrsRepLibList = ['Produit', 'Nbre. Séchoir', 'Qté.', 'Observation']
				
				let	detailsTop = '<FONT size=5><b>'+modelName+' </b> </FONT>';
				let detailsTopC1 = '<i> '+ this.$t('servteam.id') +' : </i> <b> ' +this.instance.id?.toString() + '</b>';
				detailsTopC1 = detailsTopC1+  '<br><i> '+ this.$t('servteam.servDate') +'</i> <b>' + this.$moment(this.instance.servDate).format(this.$store.getters.formatDateShort) + '</b>';

				// detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t('servorder.prsStore') +' : </i> <b> ' +this.instance.prsStore?.storeName + '</b>';

				let detailsTopC2 = '<i> '+ this.$t('servteam.prsTeam') +' : </i> <b> ' +this.instance.prsTeamLib+ '</b>'; 

				// let	detailsTopC2 = '<i> Bamako le, </i> <b>' + this.$moment(this.instance.servDate).format(this.$store.getters.formatDateShort) + '</b>';

				let trFoot = ''
				let	detailsBot = '. <br>.'
				let libBot = '<i> Commentaires (Problèmes, Pannes, Solutions, Suggestions, etc.) </i>'

				let strParams = "jasper=LIC&typeList=criteria&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				
				let strParamsForms = "params1=servTeam.id&valParams1="+this.itemId +"&logParams1=eqL"
				strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()
				strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+ this.$t(this.instanceClassAttr.instanceClass +'.servOp')

				let fileName = modelName + '_'+this.instance.orderNumber
				strParams = strParams + "&fileName="+ fileName
				// strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.prsStore?.storeName +' ***</i></FONT> '
				await this.$store.dispatch('axiosGet', {
					url: '/api/servop/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},


		}
		
	}

</script>